<template>
  <div class="grid gap-10 sm:grid-cols-5">
    <aside class="space-y-8 sm:col-span-2">
      <figure
        class="flex max-w-64 flex-col items-center gap-2 bg-white p-3 shadow-md transition-all duration-500 dark:bg-gray-800"
        :class="{
          '-rotate-2 !shadow-lg': showPhoto,
        }"
      >
        <img
          :src="imagePath"
          class="h-64 w-full object-cover"
          alt="Foto Oepke Noordmans"
        />
        <img
          :src="autographPath"
          class="max-w-50 w-full dark:hidden"
          alt="Handtekening Oepke Noordmans"
        />
        <img
          :src="autographDarkPath"
          class="max-w-50 hidden w-full dark:block"
          alt="Handtekening Oepke Noordmans"
        />
      </figure>

      <a
        v-if="false"
        class="group flex flex-col gap-4"
        href="https://www.tvz-verlag.ch/buch/neuschoepfung-9783290187002/?page_id=1&utm_source=stichtingnoordmans"
      >
        <img
          src="/neuschopfung.jpg"
          alt="Cover Neuschopfung"
          class="rounded-2xl border-4 border-white shadow-md transition-all group-hover:rotate-2 group-hover:scale-105 group-hover:shadow-xl"
        />

        <span class="px-6 text-center font-sans text-xs font-semibold"
          ><span class="whitespace-nowrap">Nieuwe vertaling Herschepping</span>
          nu beschikbaar bij TVZ</span
        >
      </a>
    </aside>

    <section class="space-y-6 pb-6 sm:col-span-3">
      <div class="space-y-3">
        <h2 class="text-xl font-bold">Nieuws</h2>

        <div class="space-y-5">
          <article class="space-y-1 bg-amber-200 p-4 px-6 text-black shadow-xl">
            <h3 class="text-lg font-bold">Studiedag 16 april 2026</h3>
            <h4 class="text font-bold">Herschepping: Woordwereld en ascese</h4>
            <p>
              Wat is Noordmans precies aan het doen in zijn fameuze
              Herschepping? Wat zit er eigen- lijk achter de titel van dit boek,
              het begrip ‘herschepping’? Toen zij een inleiding schre- ven voor
              de Duitse vertaling van het boek, die in 2025 onder de titel
              ‘Neuschöpfung’ is verschenen, realiseerden prof.dr. Gerrit Neven
              en dr. Akke van der Kooi zich dat de woorden ‘Woordwereld’ en
              ‘ascese’ een centrale rol spelen in het goed begrijpen van dit
              boek. Aan de Schrift ligt een oorspronkelijkheid ten grondslag
              waar je in de uitleg ervan weer bij wilt komen. Noordmans wil daar
              een weg in wijzen. Tijdens de studiedag proberen we hier dieper in
              door te dringen.
            </p>
            <p class="font-bold">Locatie: PThU-gebouw, Jansdam, Utrecht</p>
            <p class="!mt-3 border-t border-black pt-2">
              Meer informatie:
              <a
                href="https://stichtingnoordmans.nl/api/files/d70a4acf-34eb-4ecc-aa3c-fd77152716df"
                class="underline"
                >Nieuwsbrief 24</a
              >
              (p.2)<br>
              Ter bestudering: <a href="/api/files/77544e4a-7fdc-4753-b7bf-06362d426a50" class="underline">Inleiding bij Neuschöpfung</a>
            </p>
          </article>
        </div>
      </div>

      <NewsletterList />
    </section>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'

  import imagePath from '../assets/photo.jpg'
  import autographPath from '../assets/autograph.png'
  import autographDarkPath from '../assets/autograph-white.png'

  import NewsletterList from '../components/NewsletterList.vue'

  const showPhoto = ref(false)
  setTimeout(() => (showPhoto.value = true), 150)
</script>
